import { EnvironmentProviders, Provider, makeEnvironmentProviders } from "@angular/core";
import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslationService } from "./translation.service";
import { TranslationLoader } from "./loaders/TranslationLoader";
import { TranslationHttpLoader } from "./loaders/TranslationHttpLoader";
import { of } from "rxjs";
import { environment } from "@environments/environment";

const defaultLang = getDefaultLang();
export function provideTranslation(): (Provider | EnvironmentProviders)[] {
  return [
    makeEnvironmentProviders([
      TranslationService,
      {
        provide: TranslationLoader,
        useExisting: TranslateLoader,
      },
    ]),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationHttpLoader,
        deps: [HttpClient],
      },
      defaultLanguage: defaultLang,
      extend: true,
      isolate: false,
    }),
  ];
}

export function initializeTranslation(translationService: TranslationService) {
  const savedLang = translationService.getUserLang();
  if (savedLang) {
    return translationService.use(savedLang);
  }
  return of(null);
}

export function getDefaultLang() {
  const stored = localStorage.getItem("language");
  if (stored) {
    return JSON.parse(stored);
  }
  if ("DEFAULT_LANG" in environment) {
    return environment.DEFAULT_LANG;
  }
  return "en";
}
